import { Navigate } from 'react-router-dom';
import { useRefreshUserOnRouteChange } from '../hooks/useRefreshUserOnRouteChange';
import FlowLayoutShell from './FlowLayoutShell';

const OnboardingLayout = () => {
    const user = useRefreshUserOnRouteChange();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (user?.userQuestions) {
        return <Navigate to="/dashboard" replace />;
    }

    return <FlowLayoutShell contentClassName="onboarding-content" />;
};

export default OnboardingLayout;
